import PropTypes from 'prop-types'
import React from 'react'
import useTranslation from 'next-translate/useTranslation'

export const Header = ({onClick, currentPage}) => {
  const { t } = useTranslation('common')

  return (
    <div className='oglasi-tab-header'>
      <ul>
        <li className={currentPage === 'similarAds' ? 'active' : ''}>
          <a href='javascript:void(0)' onClick={() => onClick('similarAds')}>
            <i className='ico-tab-slicni-oglasi ico' />{t('Slični oglasi')}
          </a>
        </li>
        <li className={currentPage === 'images' ? 'active' : ''}>
          <a href='javascript:void(0)' onClick={() => onClick('images')}>
            <i className='ico-tab-fotografije ico' /> {t('Fotografije')}
          </a>
        </li>
      </ul>
    </div>
  )
}

Header.propTypes = {
  onClick: PropTypes.func.isRequired,
  currentPage: PropTypes.string.isRequired
}
